// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"6aa757e2e74e9dde37c6","293":"3642cf0888c45cb0a15d"}[chunkId] + ".js";
};